import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { fadeUp } from "@/lib/motion";
import { SERVICES } from "@/data/content";

const ServicesSection = () => {
  return (
    <section className="relative py-24 sm:py-32 bg-[#F8FAFC] overflow-hidden" id="services" data-testid="services-section">
      <div className="absolute inset-0 bg-grid opacity-60 pointer-events-none" />
      <div className="relative max-w-[1320px] mx-auto px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <SectionHeading
            overline="Core Services"
            title="Complete Certification, Managed End-to-End"
            description="Six specialized services covering the full certification lifecycle — from applicability study to final approval."
          />
          <Reveal>
            <Link
              to="/services"
              data-testid="services-view-all"
              className="inline-flex items-center gap-2 rounded-full border border-slate-300 bg-white px-6 py-3 font-semibold text-[#0F172A] hover:border-[#1E40AF] hover:text-[#1E40AF] transition-colors shrink-0"
            >
              View All Services <ArrowRight className="w-4 h-4" />
            </Link>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => (
            <Reveal key={s.slug} variants={fadeUp} custom={i % 3}>
              <Link
                to={`/services#${s.slug}`}
                data-testid={`service-card-${s.slug}`}
                className="group relative flex flex-col h-full rounded-2xl bg-white border border-slate-200 p-8 hover:-translate-y-1.5 hover:shadow-2xl hover:shadow-slate-900/10 hover:border-[#1E40AF]/30 transition-[transform,box-shadow,border-color] duration-300"
              >
                <span className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-blue-50 text-[#1E40AF] group-hover:bg-[#1E40AF] group-hover:text-white transition-colors">
                  <s.icon className="w-6 h-6" strokeWidth={1.6} />
                </span>
                <h3 className="mt-6 font-display font-semibold text-xl text-[#0F172A] leading-snug">{s.title}</h3>
                <p className="mt-3 text-slate-500 leading-relaxed flex-1">{s.short}</p>
                <span className="mt-6 inline-flex items-center gap-2 text-[#1E40AF] font-semibold text-sm group-hover:gap-3 transition-all">
                  Learn More <ArrowRight className="w-4 h-4" />
                </span>
                <span className="absolute top-8 right-8 font-display font-bold text-5xl text-slate-100 group-hover:text-blue-100 transition-colors select-none">
                  0{i + 1}
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
